const consentTypes = ['analytics', 'marketing'] as const

type ConsentType = typeof consentTypes[number]
type ConsentChoice = 'revoke' | 'grant'

export type ConsentMapping<CookieTypes extends string> = {
  [Key in CookieTypes]: ConsentType[];
};

export type FullConsentUpdate = {
  consent: ConsentChoice,
  user_interaction: boolean,
  anonymize: "yes" | "no",
  permissions: ConsentType[]
}

/**
 * Send consent updates based on a cookie type and a mapping between cookie types and consent types
 *
 * @param mapping Curried argument: maps between site specific cookies and consent types
 * @param cookie Site specific cookie that triggers an update to consent
 * @param isAccepted Whether the site specific cookie is accepted or not
 */
export const updateConsent = <CookieType extends string>(mapping: ConsentMapping<CookieType>) => (cookie: CookieType, isAccepted: boolean) => {
  const modes = mapping[cookie]
  pushConsent(modes, isAccepted ? 'grant' : 'revoke')
}

export function sqzl(args: FullConsentUpdate) {
  const sqzl = window._sqzl
  if (sqzl) {
    sqzl.push(args);
  } else {
    console.log("Squeezly not found, failed to push event", args);
  }
}

const pushConsent = (consentType: ConsentType[], choice: ConsentChoice) => {
  sqzl({
    consent: choice,
    user_interaction: true,
    anonymize: choice == "grant" && consentType.includes("marketing") ? "no" : "yes",
    permissions: consentType
  })
}

export const defaultConsent: FullConsentUpdate = {
  consent: "revoke",
  user_interaction: false,
  anonymize: "yes",
  permissions: []
}
